import { useState } from 'react'

import * as S from './styles'

type Props = {
  imgCorretor: string
  nome: string
  pontos: number
  telefone: string
}

const Corretor = ({ imgCorretor, nome, pontos, telefone }: Props) => {
  const [contato, setContato] = useState(false)
  const mostraContato = () => {
    if (!contato) {
      setContato(true)
    } else {
      setContato(false)
    }
  }
  return (
    <S.Corretor>
      <S.ImgCorretores style={{ backgroundImage: `url(${imgCorretor})` }}>
        <img src={imgCorretor} alt={nome} />
      </S.ImgCorretores>
      <S.Dados>
        <h3>{nome}</h3>
        <p>{pontos} pontos</p>
        <a onClick={mostraContato}>ver telefone</a>
        <span className={contato ? 'is-visible' : ''}>{telefone}</span>
      </S.Dados>
    </S.Corretor>
  )
}

export default Corretor
